/// <reference path="app.definition.ts" />
import { safeWindow, safeDocument, safeJQuery, globals, isIE11, isIPad, isBrowser } from './common/browser-compat';


import { APIs } from '@common/model/apis';
const angular = require('angular');
// Make angular available globally for the rest of the code
if (typeof window !== 'undefined') {
    (window as any).angular = angular;
}
import { FrameworkConfig, PermissionService } from 'ecv/common/permissions';

import { Util } from '@common/util';
import { NudgeService } from '@common/service/nudge.service';
import { IAppStateService } from '@common/service/appState.service';
import '@common/uploadDocuments/uploadDocuments.module';
import '@common/itemBoard/itemBoard.module';
import '@app/library/PdfViewer/pdfViewer.module';
import '@common/validation.rule';
import { ModuleFederationService } from '@common/service/moduleFederation.service';

angular.module('eCareVault', ['ui.router',
        'ui.bootstrap',
        'ui.select',
        'utf8-base64',
        'ngMaterial',
        'oc.lazyLoad',
        'eCareVault.common',
        'eCareVault.common.uploadDocuments',
        'eCareVault.common.itemBoard',
        'eCareVault.authentication',
        'eCareVault.PdfViewer',
        'ngIntlTelInput',
        'validation',
        'validation.rule',
        'validation.match',
        'ec.stateloader',
        'ngImgCrop',
        'ngIdle',
        'bootstrapLightbox',
        'ngTouch',
        'ngclipboard',
        'angularMoment',
        'focus-if',
        'angucomplete-alt',
        'ngFileUpload',
        'ngTable',
        'md.data.table',
        'ngMessages',
        'md.time.picker',
        'ui.sortable',
        'ngSanitize'
]);

// Continue with the rest of the module definition
angular.module('eCareVault')
    .config(['$ocLazyLoadProvider', function($ocLazyLoadProvider) {
        // Prevent oclazyload from re-running config blocks
        $ocLazyLoadProvider.config({
            rerunnable: false
        });
    }])
    .run([
        '$rootScope',
        'MultipleUploadService',
        'WebSocketService',
        '$timeout',
        '$state',
        "CacheService",
        "ApiAdapterService",
        "CommonService",
        "$location",
        "$window",
        "moment",
        "NudgeService",
        "AppStateService",
        "SnackbarService",
        "DocumentFolderService",
        "AuthenticationService",
        "UserService",
        "SubjectService",
        "ValidationService",
        "TeamService",
        "TeamPermissionService",
        "PermissionService",
        "FormService",
        function (
            $rootScope,
            MultipleUploadService,
            WebSocketService,
            $timeout,
            $state,
            CacheService,
            ApiAdapterService,
            CommonService,
            $location,
            $window: ng.IWindowService,
            moment,
            $_nudge: NudgeService,
            $_appState: IAppStateService,
            $_snackbarSvc,
            $_docFolderSvc,
            authService,
            UserService,
            SubjectService,
            ValidationService,
            TeamService,
            $_teamPerm,
            permService,
            FormService
        ) {

            toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": true,
            "progressBar": false,
            "positionClass": "toast-top-full-width",
            "preventDuplicates": false,
            "iconClasses": {
                "error": 'ecv-toast-error',
                "info": 'ecv-toast-info',
                "success": 'ecv-toast-success',
                "warning": 'toast-warning'
            },
            "onclick": null,
            "showDuration": 300,
            "hideDuration": 300,
            "containerId": 'toast-container',
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn", //"slideUp", //
            "hideMethod": "fadeOut" //"slideDown", //
        };
            // Use safe window reference for print method
            $rootScope.print = isBrowser ? safeWindow.print : () => {}; // for fixing WEB-31881

            $rootScope.logout = (form?: boolean) => {
                if ($state.current.name == "parent.forms.fill") {
                    if (!!form) {
                        //do nothing
                    } else {
                        $rootScope.$broadcast('handleFormStateChange');
                        return;
                    }
                }
                if (!!MultipleUploadService.docUpldInProgress()) {
                    var confirmationMessage = Util.DOC_UPLD_PROGRESS;
                    var answer = isBrowser ? safeWindow.confirm(confirmationMessage) : false;
                    if (!answer) {
                        return;
                    }
                } else if (!!FormService.formUploadInProgress()) {
                    var confirmationMessage = Util.FORM_UPLD_PROGRESS;
                    var answer = isBrowser ? safeWindow.confirm(confirmationMessage) : false;
                    if (!answer) {
                        return;
                    }
                } else if (!!WebSocketService.docDwnldInProgress()) {
                    var confirmationMessage = Util.DOC_DWNLD_PROGRESS;
                    var answer = isBrowser ? safeWindow.confirm(confirmationMessage) : false;
                    if (!answer) {
                        return;
                    }
                }
                $rootScope.mainShowLoader = true;
                //Clear all toastr for analytics
                $_snackbarSvc.clearNotificationToastr();

                // Safe session storage access
                if (isBrowser && safeWindow.sessionStorage) {
                    delete safeWindow.sessionStorage["ecvInvite"];
                }

                CacheService.reset();
                CacheService.setToken(null);
                UserService.reset();
                SubjectService.reset();
                ValidationService.reset();
                WebSocketService.reset();
                MultipleUploadService.reset();
                FormService.resetUploads();
                Util.reset();
                $_docFolderSvc.reset();
                $_teamPerm.resetPermissions();
                $rootScope.afterSelfSignUp = false;
                authService.signOut();
                permService.destroy().catch(e => {
                    console.error("Error destroying permissions service on logout:", e);
                });
            };

            if (!$location.$$url.includes('public') && !$location.$$url.includes('external-uploads') && !$location.$$url.includes('passwordreset') && !$location.$$url.includes('contact')) {
                authService.init();
            }

            // For Redirection
            $rootScope.rootShowLoader = true;
            var activeElement;
            $rootScope.$watch(function () {
                return $rootScope.mainShowLoader || $rootScope.loginShowLoader;
            }, function (newVal, oldVal) {
                if (newVal) {
                    activeElement = isBrowser ? safeDocument.activeElement : null;
                    if (!!activeElement && activeElement.blur) {
                        activeElement.blur();
                    }
                }
                else if (!!activeElement && activeElement.focus) {
                    activeElement.focus();
                }
            });

            $location.search('_ga', undefined);

            // Safe window event listener
            if (isBrowser) {
                $window.addEventListener('beforeunload', (e) => {
                    setTimeout(() => {
                        if (safeWindow.localStorage) {
                            safeWindow.localStorage['tabCloseTime'] = moment().valueOf();
                        }
                    }, 0);
                });

                safeWindow.addEventListener('focus', function (e) {
                    var authRes = CacheService.getAuthResponse();
                    console.log("Inside the focus in....");

                    //If coming from Safe Passage then check for active session
                    let lh = CacheService.get('lh');
                    if(!!lh){
                        const status = safeWindow.localStorage ? safeWindow.localStorage.getItem('status') : null;
                        !!status && ($rootScope.logout());
                    }
                    /////////////////////

                    if (authRes && authRes.idTokenClaims.exp) {
                        let now = moment();
                        let exp = moment(authRes.idTokenClaims.exp * 1000, 'x');
                        let diff = moment.duration(exp.diff(now));
                        if (diff.asMinutes() < 16) {
                            // if difference in minutes between expiration time of the token and current time
                            // is less than or equals to 15m then check that is user was idle till this time
                            // if so, then logout
                            var passwordModal = angular.element('body').find('.password-modal');
                            if (passwordModal.length > 0) {
                                console.log("Logging you out as you have an idle session for more than 45m....");
                                $rootScope.logout();
                            }
                        }
                    }
                });
            }

            //$_nudge.init();

            $rootScope.$on('$stateChangeStart', function (evt, to, params, from) {
                // Only warn when the navigation actually takes the user OUT of the
                // application (Back/Forward landing on login, or a session exit) while a
                // document upload is still being pushed to storage - leaving cancels it.
                // Moving between screens keeps the upload running, so in-app transitions
                // must not prompt, even though they destroy the current component.
                // Backing out of the app entirely is a real document unload and stays
                // covered by MultipleUploadService's "beforeunload" handler.
                if (to.name == 'login' && from.name != 'login' && !!MultipleUploadService.docUpldInProgress()) {
                    let leaveConfirmed = isBrowser ? safeWindow.confirm(Util.DOC_UPLD_LEAVE_PROGRESS) : true;
                    if (!leaveConfirmed) {
                        evt.preventDefault();
                        $rootScope.mainShowLoader = false;
                        return;
                    }
                }

                $timeout(() => {
                    // Safe jQuery window scroll
                    if (isBrowser && typeof $ !== 'undefined') {
                        $(safeWindow).scrollTop(0);
                    }
                }, 100);

                $_snackbarSvc.checkForSnackbar(evt, to, params, from);

                // Safe localStorage access
                let tabCloseTime = isBrowser && safeWindow.localStorage ?
                    safeWindow.localStorage['tabCloseTime'] : null;

                if (!!tabCloseTime && tabCloseTime > 0 && to.name != 'login') {
                    let now = moment();
                    let ctm = moment(tabCloseTime, 'x');
                    let diff = moment.duration(now.diff(ctm));
                    let after = diff.asSeconds() > 5;
                    if (after) {
                    } else {
                        if (isBrowser && safeWindow.localStorage) {
                            safeWindow.localStorage['tabCloseTime'] = -1;
                        }
                    }
                } else {
                    console.log("No window unload detected");
                }

                // ... rest of the existing stateChangeStart logic remains the same ...
                // if child doesnt exist - dont let user enter
                if ((to.parent == "discussion-board" ||
                    to.parent == "list-document" ||
                    to.parent == "parent-team-vault"
                ) && (CacheService.getTotalSubjects() == 0)) {
                    $rootScope.rootShowLoader = false;
                    $rootScope.mainShowLoader = false;
                    evt.preventDefault();
                    $state.go('login');
                    return;
                } else {
                    if (to.name == 'parent-list-children' && CacheService.getRole() == 'parent' && CacheService.getCurrentSubject()) {
                        if (from.name != 'list-document') {
                            evt.preventDefault();
                            $rootScope.mainShowLoader = false;
                            $state.go('documents-load', { action: 'list-document' }, { reload: true });
                        }
                    }

                }
                // If the state has default redirect attribute
                if (to.redirectTo) {
                    evt.preventDefault();
                    $state.go(to.redirectTo, params)
                } else {
                    if (to.redirectTo != from.name) {
                        $rootScope.mainShowLoader = true;
                    }
                    if (!CacheService.getUser() && to.name != "login" && to.name != "password-reset" && to.name != "privacy_out" && to.name != "terms_out" && to.name != "contact_out" && to.name != "shared_out" && to.name != "shared_out_link" && to.name != "fax_uploads_out") {
                        evt.preventDefault();
                        var path = $location.path();
                        var params = $location.search();
                        // set the redirectUrl and params in the cache.
                        let redirectTo = {
                            path : path ,
                            params : params
                        }
                        if (isBrowser && safeWindow.localStorage) {
                            safeWindow.localStorage.setItem("redirect_url",JSON.stringify(redirectTo));
                        }
                        $state.go("login", params);
                    }
                }

                if ((from.parent == 'provider-my-goals' && to.name == 'provider-mygoals-list') ||
                    (from.parent == 'provider-team-vault' && to.name == 'provider-list-children') ||
                    (from.parent == 'provider-my-folio' && to.name == 'provider-my-folio-list-children') ||
                    (from.parent == 'provider-my-services' && to.name == 'provider-my-services-studentsview-list')) {
                    CacheService.setCurrentSubject(null);
                }

                const isDocNavigation = () => {
                    if (to.name == 'documents-load') {
                        return ['list-document', 'view-document'].includes(params.action);
                    }
                    else {
                        return ['list-document', 'view-document', 'organize'].includes(to.name);
                    }
                }

                const isRlNavigation = () => {
                    if (to.name == 'documents-load') {
                        return ['list-rl', 'view-rl-document'].includes(params.action);
                    }
                    else {
                        return ['list-rl', 'view-rl-document', 'organize'].includes(to.name);
                    }
                }

                const isDiscNavigation = () => {
                    if (to.name == 'discussions-load') {
                        return ['discussion-board-list'].includes(params.action);
                    }
                    else {
                        return ['discussion-board-list'].includes(to.name);
                    }
                }

                //Reset folders list if moving away from document page or discussion page
                if (
                    (from.name == 'list-document' && !isDocNavigation()) ||
                    (from.name == 'discussion-board-list' && !isDiscNavigation()) ||
                    (from.name == "list-rl" && !isRlNavigation()) ||
                    (from.name == 'view-document' && !isDocNavigation()) ||
                    (from.name == 'view-rl-document' && !isRlNavigation()) ||
                    (from.name == 'organize' && !(isDocNavigation() || isRlNavigation()))
                ) {
                    $_docFolderSvc.reset();
                }

                if((from.name == 'list-document' && !isDocNavigation()) || (from.name == 'list-rl' && !isRlNavigation())) {
                    CacheService.setPostSearchResultsDetails(null);
                    CacheService.setRlFolderId(null);
                    CacheService.setPostFilters(null);
                    $rootScope.searchResults = false;
                    $rootScope.showChatbot = false;
                }
                //Show chatbot when navigating from view-rl-document to list-rl
                if (from.name == 'view-rl-document') {
                    $rootScope.showChatbot = (to.name === 'list-rl');
                }
            });

            $rootScope.refreshedState = false;
            $rootScope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
                $rootScope.mainShowLoader = false;

                // Check that screen size is large and pass the new state name to the nudge service to check if a tour should be triggered
                //!$_appState.getState('ISIE11')() && $_appState.getState('SCREEN_SIZE')('large') && $timeout(() => $_nudge.postNavigate(to.name), 750);
                CommonService.resetStack();
                $rootScope.previousState = from;
                $rootScope.prevStateParams = fromParams;
            });

            $rootScope.$on('$stateNotFound', function(event, unfoundState, fromState, fromParams) {
                event.preventDefault(); // Stop the transition
                const toState = unfoundState.to;
                const teamsStates = ['parent-addmultiplesubject','parent-addproject','parent-addrecipient'];
                // Redirect to the dashboard loader state
                if (teamsStates.includes(toState)) {
                    $state.go('parent-dashboard', {action: toState, previousState: fromState, previousStateParams: fromParams}, {reload: true});
                }
            });

            $rootScope.$on('$stateChangeError', function (event, to, toParams, from, fromParams) {
                $rootScope.mainShowLoader = false;
            });

            // Bind a function to the resize window event.
            // This will let us cancel a tour if the screen size can't handle the tour,
            // or just refit the SVG overlay to the current window size
            if (isBrowser) {
                angular.element($window).bind('resize', () => {
                    // console.log("Window resizing:", $_appState.getState('SCREEN_SIZE')('large'));

                    //If screen is not large cancel a current tour (but don't disable it)
                    //$_appState.getState('SCREEN_SIZE')('large') || ($_nudge.tourIsActive() && $_nudge.endTour(true));

                    // Cancel previous resize lock
                    $timeout.cancel($rootScope.resizeTimeout);

                    // Set a timout lock to prevent this from firing more often than every .25s
                    //$rootScope.resizeTimeout = $timeout(() => $_nudge.tourIsActive() && $_nudge.refreshOverlay(), 250);
                });
            }

            // $rootScope.$watch(()=> $(document).height(), (newVal: number, oldVal: number) => newVal != oldVal && $_nudge.tourIsActive() && $_nudge.refreshOverlay() && console.log("Document resized"));

            $rootScope.spinner = {
                active: false,
                on: function () {
                    this.active = true;
                },
                off: function () {
                    this.active = false;
                }
            };

            ApiAdapterService.init((error) => {
                console.log(error);
                $state.go('login');
            });
        }])
        .constant('isNode', false)
        .constant('is_iPad', isIPad)
        .provider('ApiAdapterService', function () {
            this.$get = ['isNode', '$q', 'APIService', '$http', 'JavaApiAdapterService',
                function (isNode, $q, APIService, $http, JavaApiAdapterService) {
                    if (isNode) {
                        return null;
                    } else {
                        return JavaApiAdapterService;
                    }
                }];
        })
        .provider('PermissionService', function () {
            this.$get = ['APIService', function (APIService) {
                return new PermissionService(APIService, new FrameworkConfig({
                    userPermission: APIs.GET_PERMISSIONS_FOR_USER_V2,
                    subjectPermission: APIs.GET_PERMISSIONS_FOR_SUBJECTS
                }));
            }]
        })
        .filter('capitalize', [function () {
            return function (input) {
                return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toUpperCase() : '';
            }
        }]).config(['$locationProvider', function ($locationProvider) {
            $locationProvider.hashPrefix('');
        }])
        .config(['ngIntlTelInputProvider', function (ngIntlTelInputProvider) {
            ngIntlTelInputProvider.set({
                defaultCountry: 'us',
                autoFormat: true,
                formatOnDisplay: true,
                customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                    return "e.g. " + selectedCountryPlaceholder;
                }
            });
        }])
        .config(['IdleProvider', 'KeepaliveProvider', function (IdleProvider, KeepaliveProvider) {
            IdleProvider.idle(15 * 60); // 15 minutes idle
            IdleProvider.timeout(10); // after 30 seconds idle, time the user out
            KeepaliveProvider.interval(1); // 5 minute keep-alive ping
        }])
        .config(['LightboxProvider', function (LightboxProvider) {
            LightboxProvider.templateUrl = 'app/common/popup/galleryPopup/imageView.html';
            LightboxProvider.getImageUrl = function (image) {
                return image.image;
            };
        }])
        .config(['$validationProvider', function ($validationProvider) {
            $validationProvider.showSuccessMessage = false;
        }])
        .config(['$provide', function ($provide) {
            $provide.decorator('stateLoaderDirective', stateLoaderDirectiveOverride);
            stateLoaderDirectiveOverride.$inject = ['$delegate'];
            function stateLoaderDirectiveOverride ($delegate) {
                var directive = $delegate[0];

                directive.template = '<div class="angular-state-loader"><span ng-hide="transcluding">' +
                    '</span><ng-transclude></ng-transclude><div class="global-loader">{{forceShow == true ? "Loading..." : forceShow}}' +
                    '<div class="uil-loading-css"><div></div> <div></div> <div></div> </div></div></div> ';

                return $delegate;
            }
            $provide.decorator('mdAutocompleteDirective', mdAutoCompleteDirectiveOverride);

            mdAutoCompleteDirectiveOverride.$inject = ['$delegate'];

            function mdAutoCompleteDirectiveOverride($delegate) {
                var directive = $delegate[0];
                var compile = directive.compile;

                directive.compile = function (element, attr) {
                    var template = compile.apply(this, arguments);
                    var menuContainerId = "";
                    if (element[0].parentElement.attributes['display-as']) {
                        menuContainerId = element[0].parentElement.attributes['display-as'].value;
                        menuContainerId += '-{{inputId}}';
                    } else if (element[0].attributes['container-id']) {
                        menuContainerId = element[0].attributes['container-id'].value;
                    }
                    var menuContainer = element.find('md-virtual-repeat-container');
                    menuContainer.attr('id', menuContainerId);
                    return function (e, a) {
                        template.apply(this, arguments);
                    };
                };

                return $delegate;
            }
        }])
        .config(['$mdThemingProvider', '$mdGestureProvider', '$mdInkRippleProvider', function ($mdThemingProvider, $mdGestureProvider, $mdInkRippleProvider) {
            $mdThemingProvider.disableTheming();
            if (isIE11) {
                $mdInkRippleProvider.disableInkRipple();
                $mdGestureProvider.disableAll();
            }
        }])
        .run(
            ['$templateCache', function ($templateCache) {
                $templateCache.put("ecv_bootstrap_select/choices.tpl.html", "<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row display-grid\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
                $templateCache.put("ecv_bootstrap_select/match-multiple.tpl.html", "<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
                $templateCache.put("ecv_bootstrap_select/match.tpl.html", "<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
                $templateCache.put("ecv_bootstrap_select/no-choice.tpl.html", "<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
                $templateCache.put("ecv_bootstrap_select/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i><input type=\"search\" autocomplete=\"noauto\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$select.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" id=\"searchBox\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
                $templateCache.put("ecv_bootstrap_select/select.tpl.html", "<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"noauto\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" id=\"searchBox\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
            }
        ]);

